import React, { useState } from "react";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import mixpanel from "mixpanel-browser";
import Modal from "~/components-shared/Modal";
import toastsActionCreators from "~/store/toasts/actions";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import styled from "styled-components";
import { Alert, Box } from "~/components-shared";
import mergeMemberSchema from "~/forms/MergeMemberForm/mergeMemberSchema";
import MergeMemberForm from "~/forms/MergeMemberForm";
import memberSelectors from "~/store/members/selectors";
import api from "~/lib/api";
import { handleError } from "~/lib/helpers";
import membersActionCreators from "~/store/members/actions";
import MemberCard from "~/components/MemberCard";
import { RoutesEnum } from "~/types/enums";
import { useHistory } from "react-router-dom";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const MergeMemberModal = () => {
  const {
    t
  } = useTranslation();
  const member = useSelector(memberSelectors.getSelected);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(undefined);
  const memberId = member?.id || "";
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultValues = {
    mergeMemberId: ""
  };
  const {
    handleSubmit,
    control
  } = useForm({
    resolver: yupResolver(mergeMemberSchema),
    defaultValues
  });
  const onSubmit = handleSubmit(data => {
    setLoading(true);
    api.mergeMember(memberId, data).then(() => {
      dispatch(toastsActionCreators.pushed({
        severity: "success",
        message: t("MergeMemberModal.memberMerged"),
        timeout: 10000
      }));
      mixpanel.track(`Members Merged`, {
        memberId,
        data
      });
      dispatch(membersActionCreators.actionChanged(undefined, undefined));

      // Move user to communities page if this one is not relevant anymore
      if (location.pathname.includes(RoutesEnum.MEMBER.replace(":memberId", memberId))) {
        history.replace(RoutesEnum.MEMBERS);
      }
    }).catch(e => {
      setError(handleError(e));
    }).finally(() => {
      setLoading(false);
    });
  });
  const onCancel = () => {
    mixpanel.track(`Member Merge – Cancel ("${member?.firstName} ${member?.lastName}")`);
    dispatch(membersActionCreators.actionChanged(undefined, undefined));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("MergeMemberModal.mergeMember"),
    onClose: onCancel,
    maxWidth: "500px",
    fullWidth: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(Box, {
    s: {
      my: 5
    },
    justify: "center",
    fullWidth: true
  }, member && /*#__PURE__*/React.createElement(MemberCard, {
    color: "translucent",
    member: member,
    noActions: true,
    maxWidth: "16rem",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(MergeMemberForm, {
    control: control,
    selectedMemberId: memberId
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: onCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    loading: loading,
    onClick: onSubmit,
    s: {
      ml: 2
    },
    fullWidth: true,
    rounded: true
  }, t("common.actions.merge")))));
};
export default MergeMemberModal;